import { Button, IconButton, Stack, TextField, Typography } from "@mui/material"
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import React, { useCallback } from "react";

type OptionsRowProps = {
  icon: React.ReactNode,
  opcao: string,
  index: number,
  total: number,
  onChange: (index: number, value: string) => void,
  handleMove: (index: number, direction: 'up' | 'down') => void,
  handleDelete: (index: number) => void
}

const OptionRow = React.memo(({ icon, opcao, index, total, onChange, handleMove, handleDelete }: OptionsRowProps) => {
  return (
    <Stack direction='row' gap={2} alignItems='center' key={index}>
      {icon}
      <TextField sx={{ bgcolor: "background.default" }} fullWidth variant="outlined" value={opcao} onChange={(e) => onChange(index, e.target.value)} />
      <Stack direction='row' gap={1}>
        <IconButton onClick={() => handleMove(index, 'up')} disabled={index === 0}><ArrowUpwardIcon /></IconButton>
        <IconButton onClick={() => handleMove(index, 'down')} disabled={index === total}><ArrowDownwardIcon /></IconButton>
        <IconButton onClick={() => handleDelete(index)} disabled={total <= 1}><ClearOutlinedIcon /></IconButton>
      </Stack>
    </Stack >
  )
});

const OpcoesCampoCadastro = ({ icon, opcoes, onChange }: { icon: React.ReactNode, opcoes: string[], onChange: (newOpcoes: string[]) => void }) => {

  const handleDelete = useCallback((index: number) => {
    onChange(opcoes.filter((_, i) => i !== index));
  }, [onChange, opcoes]);

  const handleMove = useCallback((index: number, direction: 'up' | 'down') => {
    const newOpcoes = [...opcoes];
    const target = newOpcoes[index + (direction === 'up' ? -1 : 1)];
    newOpcoes[index + (direction === 'up' ? -1 : 1)] = newOpcoes[index];
    newOpcoes[index] = target;
    onChange(newOpcoes);
  }, [onChange, opcoes]);

  const handleOptionChange = useCallback((index: number, value: string) => {
    onChange(opcoes.map((o, i) => i === index ? value : o));
  }, [onChange, opcoes]);

  const addNewOption = useCallback(() => {
    onChange([...opcoes, 'Nova Opção']);
  }, [onChange, opcoes]);

  return (
    <Stack direction='column' gap={2}>
      <Stack direction='row' alignItems='center' justifyContent='space-between' width='100%' >
        <Typography variant="body1" fontWeight={700}>Itens:</Typography>
        <Button variant='text' size="large" startIcon={<AddCircleOutlineOutlinedIcon />} onClick={addNewOption}>Adicionar Item</Button>
      </Stack>
      {opcoes.map((opcao, i) => (
        <OptionRow key={i}
          icon={icon}
          opcao={opcao}
          index={i}
          total={opcoes.length - 1}
          onChange={handleOptionChange}
          handleMove={handleMove}
          handleDelete={handleDelete} />
      ))}
    </Stack>
  )
}

export default React.memo(OpcoesCampoCadastro);
